<template>
  <div class="loader-copy-container">
    <p class="small loading-copy">{{ currentCopy }}</p>
  </div>
</template>

<script>
export default {
  props: {
    copywriting: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      currentCopy: this.copywriting[0],
      copywritingIndex: 1
    };
  },
  created() {
    setInterval(() => {
      this.currentCopy = this.copywriting[this.copywritingIndex++ % this.copywriting.length];
    }, 3000)
  }
};
</script>
<style lang="scss" scoped>
  .loader-copy-container {
    width: 100%;
    padding: 0.5rem 0.5rem 0 0.5rem;
    position: absolute;
    top: 2.25rem;
    left: 0;
    text-align: center;
    animation: fadeInAndOut 3s infinite;
  }

  @keyframes fadeInAndOut {
    0% {
      opacity: 0;
      transform: translate3d(0, 15%, 0);
    }

    10%, 90% {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }

    100% {
      opacity: 0;
      transform: translate3d(0, -10%, 0);
    }
  }
</style>
